import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Visa.png")